import { graphql } from "../gql";

export const GenderAgeQuery = graphql(`
  query getGenderAge($brandName: String) {
    recommendableGenderAges(brand_name: $brandName)
  }
`);

export const BrandsQuery = graphql(`
  query getBrands {
    recommendableBrands {
      value
      explanation
    }
  }
`);

export const WidthLabelQuery = graphql(`
  query getWidth(
    $genderAge: String!
    $brandName: String!
    $styleName: String
    $sizeLocale: SizeLocale!
    $length: Float
  ) {
    recommendableWidthLabels(
      gender_age: $genderAge
      brand_name: $brandName
      style_name: $styleName
      size_locale: $sizeLocale
      length: $length
    ) {
      value
      explanation
      offsetFromDefaultWidth
      label
    }
  }
`);

export const LengthLabelQuery = graphql(`
  query getLength($genderAge: String!, $brandName: String!, $styleName: String, $sizeLocale: SizeLocale!) {
    recommendableLengthLabels(
      gender_age: $genderAge
      brand_name: $brandName
      style_name: $styleName
      size_locale: $sizeLocale
    ) {
      value
      explanation
    }
  }
`);
